// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MK-z","isFullWidth":"NK-z","landingPageVideo":"OK-z","play":"PK-z","iframeVideo":"QK-z","playHidden":"RK-z","fullwidth":"SK-z"};